const initAnchors = (anchors) => {
  const paddingScrollTop = 80;

  const observer = new IntersectionObserver(
    () => {
      const firstVisibleSection = anchors.find(
        (anchor) => anchor.section.getBoundingClientRect().top >= paddingScrollTop
      );

      anchors.forEach((anchor) =>
        anchor.anchor.setAttribute(
          "data-anchor",
          firstVisibleSection && anchor.id === firstVisibleSection.id
        )
      );
    },
    {
      root: null,
      rootMargin: `-${paddingScrollTop}px 0px 0px`,
      threshold: [0, 1],
    }
  );

  anchors.forEach((anchor) => anchor.section && observer.observe(anchor.section));
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const anchors = [...document.querySelectorAll("[data-anchor]")]?.map((anchor) => ({
      id: anchor.hash.slice(1),
      anchor: anchor,
      section: document.getElementById(anchor.hash.slice(1)),
    }));

    if (anchors.length) initAnchors(anchors);
  },
  {
    once: true,
  }
);
